import { DEFAULT_LANGUAGE } from '@/config';

/** The languages the UI is offered in. English is the source; Danish the pilot's. */
export const LANGUAGES = ['da', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];

const STORAGE_KEY = 'pm.language';

export const isLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);

/*
  Guarded like `usePersistedState`: localStorage throws in private-mode Safari
  and on an exhausted quota. Losing the choice is acceptable; taking the page
  down with it is not.
*/
export const storedLanguage = (): Language | undefined => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isLanguage(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
};

/** The choice the picker made last, else the deployment default (Danish). */
export const initialLanguage = (): Language => storedLanguage() ?? DEFAULT_LANGUAGE;

export const storeLanguage = (language: Language): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // Kept for this session only.
  }
};
